import type { Context } from 'react';
import { createContext } from 'react';

export const PageCardsContext: Context<{
	width: number;
}> = createContext({ width: 0 });
